import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { fetchGraves, fetchSectors, chooseGrave, chooseGraveyard, fetchCandles, fetchCandlesTypes } from '../../../../actions/district';
import s from '../SideDescription.scss';
import swieczki from '../img/swieczki.jpg';
import Lightbox from 'react-images';
import Candles from '../../../Candles/Candles';
import CandlesModal from '../../CandlesModal/CandlesModal';

class CmentarzeForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      prefix: 'swiebodzice',
      isMounted: false,
      graveyard: null,
      graves: null,
      zarzad: null,
      selected: {
        "features": [],
        "type": "FeatureCollection"
      },
      znicz: false,
      label: { label: 'wyszukaj...' },
      sectors: null,
      uzytkownikGrobu: null,
      grobyTabela: null,
      showMore: false,
      choosenGraveyard: null,
      optionsGraveyard: null,
      wybranyGrob: null,
      lightboxIsOpen: false,
      lightboxCurrentImg: 0,
      intl: this.props.intl,
      candlesModalIsOpen: false,
    };
  }

  componentDidMount() {
    this.setState({
      isMounted: true,
    });
  }

  componentWillReceiveProps(nextProps) {

    if(JSON.stringify(this.state.graveyard) !== JSON.stringify(nextProps.graveyard)) {
      this.setState({
        optionsGraveyard: nextProps.graveyard
      });
    }

    if(JSON.stringify(this.state.zarzad) !== JSON.stringify(nextProps.zarzad)) {
      this.setState({
        zarzad: nextProps.zarzad
      })
    }

    if (JSON.stringify(this.state.wybranyGrob) !== JSON.stringify(nextProps.wybranyGrob)){
      this.setState({
        wybranyGrob: nextProps.wybranyGrob
      });
    }

    if (JSON.stringify(this.state.sectors) !== JSON.stringify(nextProps.sectors)) {
      if (nextProps.sectors.features){
        nextProps.sectors.features.map((v, i) => {
          v.geometry.coordinates.map((b, j) => {
            b.map((n, k) => {
              let temp = n[0];
              n[0] = n[1];
              n[1] = temp;
            })
          })
        })
        this.setState({
          sectors: nextProps.sectors,
        });
      }
    }

    if (JSON.stringify(nextProps.intl) !== JSON.stringify(this.state.intl)) {
      this.setState({
        intl: nextProps.intl,
      });
    }

    if(JSON.stringify(this.state.candles) !== JSON.stringify(nextProps.candles)) {
      this.setState({
        candles: nextProps.candles
      })
    }

    if(JSON.stringify(this.state.candlesEnabled) !== JSON.stringify(nextProps.candlesEnabled)) {
      this.setState({
        candlesEnabled: nextProps.candlesEnabled
      })
    }

    if(JSON.stringify(this.state.candlesTypes) !== JSON.stringify(nextProps.candlesTypes)) {
      this.setState({
        candlesTypes: nextProps.candlesTypes
      })
    }
  }

  handleGrave = (e) => {
    let zmienna;
    let znicz = false;
    // gdy kasujemy wybor
    if (e === null) {
      this.setState({
        selected: {
          ...this.state.selected,
          features: [],
        },
        znicz: false,
        label: '',
      },
    );
    } else {f
      // wybieramy grob
      this.state.graves.features.map((v, i) => {
        if (e.id === v.properties.id) return zmienna = v;
      });
      const graveId = `grob_${zmienna.properties.id}`;

      if (localStorage.getItem(graveId) === 'zapalony') {
        znicz = true;
      } else {
        znicz = false;
      }
      // podajemy dane nowo wybranego grobu (zaraz po zresetowaniu tego state)
      this.setState({
        selected: {
          ...this.state.selected,
          features: [zmienna],
        },
        znicz: znicz,
        label: { label: `${zmienna.properties.imie} ${zmienna.properties.nazwisko} (Data zgonu: ${zmienna.properties.data_zgonu})` },
      }, () => {
        this.props.chooseGrave({
          data: zmienna.properties,
          latlng: {
            lat: zmienna.geometry.coordinates[1], lng: zmienna.geometry.coordinates[0]
          },
        });
      });
    }
  }

  selectedGrave = () => {
    let handler;
    if (this.state.selected.features.length !== 0) {
      return handler = this.state.selected.features[0].properties;
    }
    return handler;
  };

  changeSearchEngine = (str) => {
    const imienazw = str.target.value;
    if (imienazw.length >= 2) {
      fetch(`${process.env.API_URL}/cmentarze/${this.props.prefix}/znajdz/groby?imienazw=${imienazw}&id_cmentarz=${this.state.choosenGraveyard}`)
      .then(resp => {
        return resp.json();
      })
      .then(resp => {
        this.setState({
          grobyTabela: resp,
        });
      })
      .catch(err => console.error(err));
    } else if (imienazw.length <= 1 || imienazw === null) {
      this.setState({
        grobyTabela: null,
        uzytkownikGrobu: null,
      });
    }
  }

  /**
   * Funkcja pobierajaca listę zdjęć z folderu dla danego grobu
   * @param id_grobu - id grobu
   * @return object - imageExists - czy istnieja jakiekolwiek zdjecia, images - lista zdjec, error - tresc bledu
  */

  getImages = (id_grobu) => {
    const url = `${process.env.API_URL}/zdjecie_grobu/${this.props.prefix}/${id_grobu}`
    return fetch(url, {
      type: 'GET',
    })
    .then(resp => {
      return resp.json();
    })
    .then(resp => {
      let arr = [];
      if (resp.imagesExists) {
        arr = resp.images.map((v, i) => ({
          src: `${process.env.API_URL}/zdjecie_grobu/${this.props.prefix}/${id_grobu}/${v}`
        }))
      }
      resp.images = arr;
      return resp;
    })
    .catch(e => {
      console.info(e)
    })
  }

  handleChange = (obj) => {
    let cordsX = [];
    let cordsY = [];
    obj.geometry.coordinates[0].map((v, i) => {
      cordsX.push(v[0]);
      cordsY.push(v[1]);
    });

    Array.prototype.max = function() {
      return Math.max.apply(null, this);
    };

    Array.prototype.min = function() {
      return Math.min.apply(null, this);
    };

    const maxX = cordsX.max();
    const maxY = cordsY.max();
    const minX = cordsX.min();
    const minY = cordsY.min();

    this.props.chooseGraveyard([
        [maxY, maxX],
        [minY, minX]
    ]);

    this.setState({
      showMore: true,
      choosenGraveyard: obj.properties.id,
      uzytkownikGrobu: null
    }, () => {
      this.searchEngineNode.scrollIntoView({behavior: "smooth"});
    })
  }

  chooseGrave = (item) => {
    const id_zmarlego = item.target.value;
    console.log('choose')

    if (id_zmarlego.length > 0) {
      fetch(`${process.env.API_URL}/cmentarze/${this.props.prefix}/grob?idzmarlego=${id_zmarlego}&all_buried=True`)
      .then(resp => {
        return resp.json();
      })
      .then(resp => {
        const zmarly = resp.zmarli.find(zm => zm.id == id_zmarlego);
        this.setState({
          uzytkownikGrobu: Object.assign({
            nr_ewid_sektor: resp.nr_ewid_sektor,
            nr_ewid_rzad: resp.nr_ewid_rzad,
            nr_ewid_grob: resp.nr_ewid_grob,
            lat: resp.lat,
            lng: resp.lng,
          }, zmarly)
        }, () => {
          // wysyłamy dane do mapka w MapControl.js
          this.getImages(resp.PK_UID)
          .then(respImg => {
            this.props.chooseGrave({
              data: resp,
              latlng: { lat: resp.lat, lng: resp.lng },
              images: respImg,
              change: true,
              changeZoom: true
            });
            this.gravesInfoListNode.scrollIntoView({behavior: "smooth"});
            this.props.fetchCandles(this.props.prefix, id_zmarlego)
          })
          .catch(err => console.error(err));
        });
      })
      .catch(err => console.error(err));
    } else if (id_zmarlego.length <= 1 || id_zmarlego === null) {
      this.setState({
        uzytkownikGrobu: null,
      });
    }
  }

  tableData() {
    const tableForLabel = [
      { 'Imię:': this.state.uzytkownikGrobu.imie },
      { 'Nazwisko:': this.state.uzytkownikGrobu.nazwisko },
      { 'Data śmierci:': this.state.uzytkownikGrobu.data_zgonu },
      { 'Data urodzenia:': this.state.uzytkownikGrobu.data_urodzenia },
      { 'Wiek:': this.state.uzytkownikGrobu.wiek },
      { 'Nr sektora:': this.state.uzytkownikGrobu.nr_ewid_sektor },
      { 'Nr rzędu:': this.state.uzytkownikGrobu.nr_ewid_rzad },
      { 'Nr grobu:': this.state.uzytkownikGrobu.nr_ewid_grob },
    ];

    return tableForLabel.map((v, i) => {
      const klucz = Object.keys(v);
      const wartosc = v[klucz] ? v[klucz] : '-';
      return (
        <tr key={v + i} className={(i+1) % 2 === 1 ? 'background_table_zmarly' : ''}>
          <td className="table_zmarly"><strong>{klucz}</strong></td>
          <td className="table_zmarly">{wartosc}</td>
        </tr>
      );
    });
  }

  render() {
    return (
      <div className="cmentarze-main">
        <div className="row">
            {this.state.optionsGraveyard ? this.state.optionsGraveyard.features.map((v,i) => {
              return (
                <div className="col-md-6" key={i}>
                  <button className={this.state.choosenGraveyard === v.properties.id ? "btn-block cmentarze_button cmentarze_active" : "btn-block cmentarze_button"} onClick={() => this.handleChange(v)}>{v.properties.nazwa}</button>
                </div>
              )
            }) : null}

        </div>
        {this.state.showMore ?
        <div ref={(node) => {this.searchEngineNode = node}}>
          <div className="form-group">
            <label htmlFor="select" style={{ fontSize: '18px' }}>Wyszukaj po imieniu, nazwisku lub dacie zgonu:</label>
            <input placeholder="np.: Imię Nazwisko 01.01.1900" onChange={(e) => this.changeSearchEngine(e)} type="text" className="form-control cmentarze_area" style={{padding: '20px', fontSize: '24px', lineHeight: '24px'}} />
            <span className="fa fa-search fa-3x searchInputIcon" style={{ color: '#336633' }}></span>
          </div>
          <div className="form-group graves-info-list" style={{ width: '100%', marginTop: '20px' }}>
            <label htmlFor="listaZmarlych" style={{ fontSize: '18px' }}>Następnie wybierz zmarłego z listy:</label>
            <select onChange={(e) => this.chooseGrave(e)} size={this.state.grobyTabela !== null && this.state.grobyTabela.length < 5 ? this.state.grobyTabela.length + 1 : '5'  } className="form-control groby-select cmentarze_area" name="listaZmarlych">
              {this.state.grobyTabela !== null && this.state.grobyTabela.length === 0 ? <option>brak wyników</option> : null}
              {(this.state.grobyTabela !== null) ? this.state.grobyTabela.map((v, i) => {
                return (
                    <option key={v + i} value={v.id} style={{ padding: '5px 0', fontSize: '25px' }}>
                      &#10014; {v.nazwisko} {v.imie} zm. {v.data_zgonu}
                    </option>
                  );
              }) : null}
            </select>
            {this.state.uzytkownikGrobu ?
              <div className="graves-info-list" style={{ width: '100%', marginTop: '20px' }} ref={(node) => {this.gravesInfoListNode = node}}>
                <table>
                  <tbody>
                    {this.tableData()}
                  </tbody>
                </table>
                {this.state.wybranyGrob && this.state.wybranyGrob.images.imagesExists ?
                    <div>
                      <button onClick={() => this.setState({ lightboxIsOpen: true })} className="btn btn-block perfectCenter marginesy cmentarze-background">
                        <span key={this.state.intl.langKeys.images} style={{ height: '100%', marginRight: '10px' }}>Zdjęcia</span>
                        <span className="fa fa-file-image-o fa-2x" aria-hidden="true" />
                      </button>
                      <a
                        href={`https://maps.google.com/maps?saddr=Current+Location&daddr=${this.state.uzytkownikGrobu.lat},${this.state.uzytkownikGrobu.lng}`}
                        target="_blank"
                        className="btn btn-block perfectCenter marginesy cmentarze-background">
                        <span style={{ height: '100%', marginRight: '10px' }}>Wyznacz trasę</span>
                        <span className="fa fa-road fa-2x" aria-hidden="true" />
                      </a>
                      <Lightbox
                      currentImage={this.state.lightboxCurrentImg}
                      images={this.state.wybranyGrob.images.images}
                      isOpen={this.state.lightboxIsOpen}
                      onClose={() => this.setState({ lightboxIsOpen: false, lightboxCurrentImg: 0 })}
                      onClickNext={() => this.setState({ lightboxCurrentImg: this.state.lightboxCurrentImg + 1 })}
                      onClickPrev={() => this.setState({ lightboxCurrentImg: this.state.lightboxCurrentImg - 1 })}
                    />
                  </div> : null}
                {this.state.candlesEnabled ? (
                  this.state.wybranyGrob ?
                    <CandlesModal
                      prefix={this.props.prefix}
                      graveId={this.state.wybranyGrob.data.id}
                      candlesTypes={this.state.candlesTypes}
                      show={this.state.candlesModalIsOpen}
                      onHide={() => this.setState({candlesModalIsOpen: false})}
                      onSuccess={() =>
                        this.props.fetchCandles(this.props.prefix, this.state.wybranyGrob.data.id)
                      } /> : null,
                    <button onClick={() => this.setState({ candlesModalIsOpen: true})}
                      className="btn btn-block perfectCenter marginesy cmentarze-background">
                      <span style={{ height: '100%', marginRight: '10px' }}>Zapal znicz</span>
                      <span className="fa fa-fire fa-2x" aria-hidden="true" />
                    </button>
                  ) : null}
              </div>
            : null }
          </div>
        </div> : null }
        {this.props.prefix === 'ketrzyn'
        ? <div>
          <p>
            <strong>
              Wniosek o dzierżawę:
            </strong><br />
            (zgodnie z Uchwałą Nr VI/46/2019 w sprawie ustalenia opłat za miejsce grzebalne 
            i usługi na terenie cmentarzy Gminy Miejskiej Kętrzyn)
          </p>
          <ul>
            <li>150.00 zł za miejsce dla osoby dorosłej grób ziemny</li>
            <li>50.00 zł za miejsce pod grób ziemny dla dziecka do lat 6</li>
            <li>70.00 zł za miejsce ziemne na 1 urnę</li>
          </ul>
          <p>
            <strong>
              Wniosek o miejsce:
            </strong><br />
            (zgodnie z Uchwałą Nr VI/46/2019 w sprawie ustalenia opłat za miejsce grzebalne 
            i usługi na terenie cmentarzy Gminy Miejskiej Kętrzyn)
          </p>
          <ul>
            <li>500.00 zł za rezerwację miejsca grzebalnego pod grób ziemny</li>
            <li>1000.00 zł za 1 miejsce pod grobowiec</li>
            <li>100.00 zł rezerwacja miejsca ziemnego pod urnę</li>
            <li>1400.00 zł za udostępnienie niższy w ścianie urnowej kolumbarium na 20 lat</li>
          </ul>
        </div> : null}
        <div className="row phone-site-info">
          <div className="col-md-12">
            Otwórz stronę na telefonie:<br />
          </div>
        </div>
        <div className="row phone-site-info">
          <div className="col-md-4" style={{ marginLeft: '0' }}>
            <img src={`${process.env.API_URL}/cmentarze/qr/${this.props.prefix}`} style={{ marginLeft: '0' }} alt="QR Icon"/>
          </div>
          <div className="col-md-8">
          {this.state.candlesEnabled ?
            <Candles candles={this.state.candles} candlesTypes={this.state.candlesTypes}/>
            : null}
          </div>
        </div>
        <div className="row">
          <div className="col-md-8" style={{ marginLeft: '0' }}>
              {this.state.zarzad ?
              <table className="zarzad_table">
                <tr>
                  <td>Nazwa zarządu</td>
                  <td>{this.state.zarzad.nazwa}</td>
                </tr>
                <tr>
                  <td>Adres</td>
                  <td>{this.state.zarzad.ulica} {this.state.zarzad.nr_budynku}{this.state.zarzad.nr_lokalu ? '/' + this.state.zarzad.nr_lokalu : null}, {this.state.zarzad.kod_pocztowy} {this.state.zarzad.miejscowosc}</td>
                </tr>
                {this.state.zarzad.godziny_otwarcia ? <tr>
                  <td>Godziny otwarcia biura</td>
                  <td>{this.state.zarzad.godziny_otwarcia}</td>
                </tr> : null}
                {this.state.zarzad.telefon ?
                <tr>
                  <td>Telefon</td>
                  <td>{this.state.zarzad.telefon}</td>
                </tr> : null}
                {this.state.zarzad.email ?
                <tr>
                  <td>Email</td>
                  <td>{this.state.zarzad.email}</td>
                </tr> : null}
                {this.state.zarzad.add_info ?
                <tr>
                  <td>Informacja</td>
                  <td>{this.state.zarzad.add_info}<br />
                      {this.state.zarzad.telefon2}</td>
                </tr> : null}
                {this.state.zarzad.strona ?
                <tr>
                  <td>Link do strony</td>
                  <td><a href={this.state.zarzad.strona}>Przejdź</a></td>
                </tr> : null}
                {this.state.zarzad.cennik ?
                <tr>
                  <td>Cennik cmentarza</td>
                  <td><a href={this.state.zarzad.cennik}>Pokaż</a></td>
                </tr> : null}
                {this.state.zarzad.regulamin ?
                <tr>
                  <td>Regulamin cmentarza</td>
                  <td><a href={this.state.zarzad.regulamin}>Pokaż</a></td>
                </tr> : null}
              </table> : null}
          </div>
        </div>
        <div className="row">
          <div className="col-md-12" style={{ marginLeft: '0' }}>
              <img src={swieczki} style={{ height: '150px', marginLeft: '-25px', marginBottom: '-30px' }} alt="Candles Icon" />
          </div>
        </div>
      </div>
    );
  }
}

CmentarzeForm.propTypes = {
  chooseGrave: PropTypes.func,
  prefix: PropTypes.string,
};

const mapState = (state) => ({
  intl: state.intl,
  graves: state.district.graves,
  sectors: state.district.sectors,
  prefix: state.district.district.prefix,
  graveyard: state.district.graveyard,
  zarzad: state.district.zarzad,
  wybranyGrob: state.district.chosenGrave,
  candlesEnabled: state.district.candlesEnabled,
  candles: state.district.candles,
  candlesTypes: state.district.candlesTypes,
});

// pobiera z reduxa wybrane funkcje typu actions
const mapDispatch = {
  fetchGraves,
  fetchSectors,
  chooseGrave,
  chooseGraveyard,
  fetchCandles,
  fetchCandlesTypes,
};

export default withStyles(s)(connect(mapState, mapDispatch)(CmentarzeForm));



// WEBPACK FOOTER //
// src/components/Modals/SideDescription/content/CmentarzeForm.js